import {
  ET_CATEGORIES,
  ET_HIGHLIGHTS,
  resolveHighlightKey,
  resolveThresholdKey,
} from "./reportViews";
import styles from "./styles.module.css";

// Figma polygon paths (7119-1239 / 1244 / 1249), drawn at their native size.
const TRIANGLE_PATH =
  "M4.98494 0.799805C5.1389 0.533178 5.52433 0.533178 5.6783 0.799805L10.0084 8.2998C10.1623 8.56647 9.96962 8.90039 9.6617 8.90039H1.00154C0.693621 8.90039 0.500901 8.56647 0.654861 8.2998L4.98494 0.799805Z";
const DIAMOND_PATH =
  "M10.7577 6.58579L6.58579 10.7577L2.41391 6.58579L6.58579 2.41391L10.7577 6.58579Z";

/** Systolic BP category marker: ▽ hypotension, ▲ stage 2, ◆ hypertensive care. */
export const ThresholdIcon = ({ category }) => {
  const meta = ET_CATEGORIES[category];
  if (!meta) return <span className={styles.etIcon} aria-hidden="true" />;

  if (meta.shape === "diamond") {
    return (
      <span className={styles.etIcon} aria-hidden="true">
        <svg width="13" height="13" viewBox="0 0 13.1716 13.1716" fill="none">
          <path d={DIAMOND_PATH} stroke={meta.color} strokeWidth="4" />
        </svg>
      </span>
    );
  }

  const filled = meta.shape === "triangleUp";
  return (
    <span className={styles.etIcon} aria-hidden="true">
      <svg
        width="11"
        height="10"
        viewBox="0 0 10.6632 9.5"
        fill="none"
        style={meta.shape === "triangleDown" ? { transform: "rotate(180deg)" } : undefined}
      >
        <path
          d={TRIANGLE_PATH}
          fill={filled ? meta.color : "none"}
          stroke={meta.color}
          strokeWidth="1.2"
        />
      </svg>
    </span>
  );
};

/**
 * Extended Threshold keys (SCRUM-790, Figma 7119-1233): the Systolic BP
 * threshold card and the consecutive-report Row Colors card. Rendered from
 * the snapshot's `threshold_key` / `highlight_key` when generated, with the
 * Figma defaults before that.
 */
const ExtendedThresholdLegend = ({ thresholdKey, highlightKey }) => (
  <div className={`${styles.legend} ${styles.etLegend}`}>
    <div className={`${styles.legendCard} ${styles.etThresholdCard}`}>
      <div className={styles.legendTitle}>Systolic BP</div>
      <div className={styles.legendCats}>
        {resolveThresholdKey(thresholdKey).map((k) => (
          <div key={k.category} className={styles.legendCat}>
            <ThresholdIcon category={k.category} />
            <div>
              <div className={styles.legendCatLabel}>{k.label}</div>
              <div className={styles.legendCatRange}>{k.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className={`${styles.legendCard} ${styles.etRowColorsCard}`}>
      <div className={styles.legendTitle}>Row Colors</div>
      <div className={styles.legendCats}>
        {resolveHighlightKey(highlightKey).map((k) => (
          <div key={k.highlight} className={styles.legendCat}>
            <span
              className={styles.etSwatch}
              style={{ backgroundColor: ET_HIGHLIGHTS[k.highlight].swatch }}
            />
            <span className={styles.legendCatLabel}>= {k.description}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ExtendedThresholdLegend;
